(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
jQuery(window).on('load', function () {

  jQuery('.av-js-hamburger').click(function () {
    jQuery('body').toggleClass('sidenav-opned');
  });

  // slick slider
  jQuery('.tech-slider ul.sliderwrap-main').slick({
    infinite: true,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    speed: 500
  });

  // for desktop slider
  jQuery(".tech-slider-desktopgrid .sliderwrap-main .slick-dots, .tech-slider-desktopgrid .sliderwrap-main .slick-arrow").wrapAll("<div class='slick-controls slick-controls-desktop' />");


  // for responsive slider in tab
  jQuery(".tech-slider-responsive #tab-id-1-container .sliderwrap-main .slick-dots, .tech-slider-responsive #tab-id-1-container .sliderwrap-main .slick-arrow").wrapAll("<div class='slick-controls slick-controls-responsive' />");

  // for responsive slider in tab
  jQuery(".tech-slider-responsive #tab-id-2-container .sliderwrap-main .slick-dots, .tech-slider-responsive  #tab-id-2-container .sliderwrap-main .slick-arrow").wrapAll("<div class='slick-controls slick-controls-responsive' />");


  // for slider wrapper main, 
  jQuery(".techslider-left-section.one-section, .techslider-right-section.one-section, .techslider-middle-section.one-section").wrapAll("<div class='techslider-parentclass' />");

  // custom jquery for scroll icon
  (function ($) {
    $.fn.visible = function (partial) {
      var $t = $(this),
        $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top,
        _bottom = _top + $t.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;
      return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };
  })($);

  function visible(elem) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();

        var elemTop = $(elem).offset().top;
        var elemBottom = elemTop + $(elem).height();

        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }

  $(window).scroll(function (event) {

    $(".three-grid-animation .av-content-full .av_one_third").each(function (i, el) {
      var el = $(el);
      if (el.visible(true)) {
        jQuery(".three-grid-animation .av-content-full .av_one_third").addClass("animate__animated animate__fadeIn");
      }

      else {
        jQuery('.scroll-icon').removeClass('black-icon');
        jQuery('.pum-trigger').removeClass('black-icon');
      }
    });
        
    $(".page-template .section-inovation .inovation-col-1").each(function (i, el) {
      var el = $(el);
      if (el.visible(true)) {
        jQuery(".page-template .section-inovation").addClass("show-inovation");
      }
    });

    $("#wrap_all .white-bg-section").each(function (i, el) {
      var el = $(el);
      if (el.visible(true)) {
        $('.scroll-icon').addClass('black-icon');
        $('.scroll-icon').removeClass('hide-scrollicon');
        $('.fixed-position-tagline').removeClass('color-light');
        $('.fixed-position-tagline').removeClass('hide-position-tagline');
        $('.fixed-position-tagline').addClass('color-dark');
        $('.pum-trigger').addClass('black-icon');
      }
    });

    $("#wrap_all .white-content-textline").each(function (i, el) {
      var el = $(el);
      if (el.visible(true)) {
        $('.fixed-position-tagline').removeClass('color-dark');
        $('.fixed-position-tagline').removeClass('hide-position-tagline');
        $('.fixed-position-tagline').addClass('color-light');
      }
    });

    $("#wrap_all .white-bg-section .title-margin-custom h2, #wrap_all .animate-section-title-wrap h2, .animated-title-class").each(function (i, el) {
      var el = $(el);
      if (el.visible(true)) {
        $(this).addClass('animate__animated animate__fadeIn');
      }
    });

    $("#footer").each(function (i, el) {
      var el = $(el);
      if (el.visible(true)) {
        $('.scroll-icon').addClass('hide-scrollicon');
        $('.fixed-position-tagline').addClass('hide-position-tagline');
        $('.fixed-position-tagline').removeClass('color-dark');
        $('.pum-trigger').removeClass('black-icon');
      }
    });

    $(".scroll-hidepopup-position-one").each(function (i, el) {
      var el = $(el);
      if (el.visible(true)) {
        // $('.pum-trigger').addClass('add-color-transparant');
      }

      else {
        // $('.pum-trigger').removeClass('add-color-transparant');
      }
    });

    $(".scroll-hidepopup-position-two").each(function (i, el) {
      var el = $(el);
      if (el.visible(true)) {
        // $('.pum-trigger').removeClass('add-color-transparant');
      }
    });

    $(".scroll-hidepopup-position-footer-one").each(function (i, el) {
      var el = $(el);
      if (el.visible(true)) {
        // $('.pum-trigger').addClass('add-footer-transparant');
      }

      else {
        // $('.pum-trigger').removeClass('add-footer-transparant');
      }
    });

    $(".scroll-hidepopup-position-footer-two").each(function (i, el) {
      var el = $(el);
      if (el.visible(true)) {

        // $('.pum-trigger').removeClass('add-footer-transparant');
        $('.pum-trigger').addClass('footer-inview-popup');
      }

      else {
        $('.pum-trigger').removeClass('footer-inview-popup');
      }
    });

    // for add class in footer
    $("footer#socket, #footer").each(function (i, el) {
      var el = $(el);
      if (el.visible(true)) {
        $('.pum-trigger').addClass('footer-inview-popup');
      }
    });

  });
});

jQuery( document ).ready(function() {
  var valueList = jQuery(".equipment_validation_list ul li").length;
  

  jQuery( ".open_list" ).click(function() {
    jQuery(".equipment_validation_list ul li").addClass("visible");
    jQuery(".open_list").css("visibility","hidden");
  });

  if (valueList <= 24) {
    jQuery(".open_list").css("visibility","hidden");
  }

  $('.video-wrapper').click(function () {
     	     
    if(document.querySelector('.video-wrapper video').paused){
      document.querySelector('.video-wrapper video').play();
      jQuery(".playpause").fadeOut();
    }
    else {
      document.querySelector('.video-wrapper video').pause();
      jQuery(".playpause").fadeIn();
    }
  });
});

},{}]},{},[1])